import { Icon, ExternalLink } from '@monash/portal-react';
import React, { useContext } from 'react';
import Card from '../../../ui/card/Card';
import InfoItem from '../info-item/InfoItem';
import { StudentContext } from '../../../providers/StudentProvider';
import { formatAmount } from '../../../utilities/functions/format-amount';
import c from './m-pass.module.scss';

const MPass = () => {
  const { profileData } = useContext(StudentContext);

  const mPassError = profileData?.errors?.find(
    (error) =>
      error.additionalDetails === 'Cardholder not found' ||
      error.additionalDetails === 'Unable to reach Transact'
  );

  const infoList = [
    {
      name: 'M-Pass account balance',
      icon: Icon.CurrencyDollar,
      data: formatAmount(profileData?.cardholder?.generalBalance),
      error: mPassError,
      action: (
        <ExternalLink
          text="Top up"
          size="small"
          variant="text"
          link="https://monash-sp.transactcampus.com/eAccounts/AnonymousHome.aspx"
          className={c.noWrap}
        />
      ),
    },
    {
      name: 'Print balance',
      icon: Icon.Printer,
      error: mPassError,
      data: formatAmount(profileData?.cardholder?.printingBalance, {
        hideEmptyValues: true,
      }),
    },
  ];

  return (
    <Card>
      {infoList.map(
        (item, i) =>
          item.data && (
            <InfoItem
              name={item.name}
              error={item.error}
              icon={item.icon}
              form={item.form}
              data={item.data}
              key={item.name}
              action={item.action}
            />
          )
      )}
    </Card>
  );
};

export default MPass;
